import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SystemCommonModule } from '../system-common/system-common.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DocumentManagementService } from './service/document-management.service';
import { DocumentManagementRoutingModule } from './document-management-routing.module';
import { DocumentManagementComponent } from './document-management/document-management.component';

@NgModule({
  declarations: [DocumentManagementComponent],
  imports: [CommonModule, FormsModule, SystemCommonModule, DocumentManagementRoutingModule, ModalModule.forRoot()],
  providers: [DocumentManagementService],
})
export class DocumentManagementModule {}
